import styled from 'styled-components';

export const TablePane = styled.div`
  flex: 1;
  overflow: auto;
  height: 100%;
  display: flex;
  .table-wrapper {
    overflow: auto;
    padding: unset;
    margin: 0;
    th:first-child {
      border-top-left-radius: 5px;
      width: fit-content;
    }
    th:last-child {
      border-top-right-radius: 5px;
    }
    tr:last-child {
      border-radius: 5px;
      td:first-child {
        border-bottom-left-radius: 5px;
      }
      td:last-child {
        border-bottom-right-radius: 5px;
      }
    }
  }
  th:first-child,
  th:last-child {
    width: 64px;
  }
  td,
  th {
    text-align: left;
    padding: 12px 12px;
  }
  table {
    .table-checkbox {
      padding-left: 12px;
    }
  }
`;
